import type { IGifsCategory } from "./types";

const GIF_QUERY_KEY = "gifs-panel-query";
const GIF_MASONRY_COLS = 3;
const GIF_MASONRY_GAPS = 8;
const GIF_MASONRY_FAKE_CELLS = 2;
const GIF_MASONRY_LOAD_SCROLL = 0.5;
const GIF_MASONRY_SKELETON_HEIGHTS = [
  [123, 97, 192],
  [127, 192, 97],
];

const GIF_CATEGORIES: IGifsCategory[] = [
  {
    key: "money",
    query: "Money",
  },
  {
    key: "thank_you",
    query: "Thank you",
  },
  {
    key: "team",
    query: "Team",
  },
  {
    key: "question",
    query: "Question",
  },
  {
    key: "wow",
    query: "Wow",
  },
  {
    key: "funny",
    query: "Funny",
  },
  {
    key: "success",
    query: "Success",
  },
  {
    key: "celebration",
    query: "Celebration",
  },
  {
    key: "confused",
    query: "Confused",
  },
  {
    key: "excited",
    query: "Excited",
  },
  {
    key: "thinking",
    query: "Thinking",
  },
];

export {
  GIF_CATEGORIES,
  GIF_MASONRY_COLS,
  GIF_MASONRY_FAKE_CELLS,
  GIF_MASONRY_GAPS,
  GIF_MASONRY_LOAD_SCROLL,
  GIF_MASONRY_SKELETON_HEIGHTS,
  GIF_QUERY_KEY,
};
